module.exports = __webpack_public_path__ + "img/KTP-154.e8ccb83a.jpg";